const passwordToggleVisibility = () => {
  let elems = document.querySelectorAll(".js-show-pwd");
  if (elems) {
    elems.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        // get elems
        let input = el.previousElementSibling;
        let open = el.querySelector('.js-eye-open');
        let closed = el.querySelector('.js-eye-closed');
        el.classList.toggle('is--visible');
        // change icon
        if(el.classList.contains('is--visible')){
            closed.classList.add('!hidden')
            open.classList.toggle('!block')
        } else {
            open.classList.remove('!block')
            closed.classList.remove('!hidden')
        }
        // update input type
        if (input.type === 'password') {
            input.setAttribute('type', 'text');
          } else {
            input.setAttribute('type', 'password');
          }
      });
    });
  }
};

export { passwordToggleVisibility };
